export const getOptionsFromObjects = <T extends { [key: string]: any }>(
  data: T[],
  labelProp: keyof T,
  valueProp: keyof T
): { label: string; value: any }[] => {
  // `.toString()` on a null/undefined label threw and took the whole screen
  // down - company_department.name is nullable, and one unnamed row was enough
  // to crash every select fed by this helper. String(x ?? "") degrades to an
  // empty label instead, which CustomTextSelect already treats as unusable.
  return data.map((item) => ({
    label: String(item[labelProp] ?? ""),
    value: item[valueProp],
  }));
};
